export default __webpack_public_path__ + "static/double-choc-3302181113e7e31f9f47b13c9007ab3c.png";